import { render, staticRenderFns } from "./CsvDownloader.vue?vue&type=template&id=1236366a&scoped=true&"
import script from "./CsvDownloader.vue?vue&type=script&lang=js&"
export * from "./CsvDownloader.vue?vue&type=script&lang=js&"
import style0 from "./CsvDownloader.vue?vue&type=style&index=0&id=1236366a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1236366a",
  null
  
)

export default component.exports